import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LatLng {
  lat: number;
  lng: number;
  name?: string;
}

interface LocationState {
  location: LatLng | null;
}

const initialState: LocationState = {
  location: null,
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocation: (state, action: PayloadAction<LatLng>) => {
      state.location = action.payload;
    },
    clearLocation: (state) => {
      state.location = null;
    },
  },
});

export const { setLocation, clearLocation } = locationSlice.actions;
export default locationSlice.reducer;
